<template>
  <div class="flex pin-card">
    <div class="flex p-3 w-full">
      <div class="flex mr-2 items-start shrink-0">
        <img :src="pinIcon" alt="Pin" />
      </div>
      <div class="flex items-start shrink-0">
        <div v-if="cardData.type === 'basic'" class="flex flex-col gap-2">
          <div class="flex">
            <img src="@/assets/MyPatient/phone_number.svg" class="mr-1" alt="Title" />
            <div class="text-wrap">{{ cardData.content.countryCode }} {{ cardData.content.phone }}</div>
          </div>
          <div class="flex">
            <img src="@/assets/MyPatient/email_address.svg" class="mr-1" alt="Title" />
            <div class="text-wrap">{{ cardData.content.email }}</div>
          </div>  
          <div class="flex">
            <img src="@/assets/MyPatient/location.svg" class="mr-1" alt="Title" />
            <div class="text-wrap">{{ cardData.content.location }}</div>
          </div>
        </div>
        <div v-else-if="cardData.type === 'dob'" class="flex flex-col gap-2">
          <div class="flex items-start">
            <img src="@/assets/MyPatient/birthday.svg" class="mr-1" alt="Title" />
            <div class="text-wrap">{{ cardData.content.dob }}<br>{{ cardData.content.age }} years old</div>
          </div>
        </div>
        <div v-else-if="cardData.type === 'emergency'" class="flex flex-col gap-2">
          <div class="flex items-start">
            <img src="@/assets/MyPatient/emergency.svg" class="mr-1" alt="Title" />
            <div class="text-wrap"><span class="text-[10px] text-[#666]">Emergency Contact:</span><br>{{ cardData.content.name }}<br>{{ cardData.content.countryCode }}{{ cardData.content.phone }}</div>
          </div>
        </div>
        <div v-else-if="cardData.type === 'medical'" class="flex flex-col gap-2">
          <div class="flex items-start">
            <img src="@/assets/MyPatient/kits_icon.svg" class="mr-1" alt="Title" />
            <div class="text-wrap"><span class="text-[10px] text-[#666]">Recent Test:</span><br>{{ cardData.testDate }}<br>{{ cardData.test }}</div>
          </div>
          <div class="report-ready">
            {{ cardData.status }}
          </div>
        </div>
        <div v-else-if="cardData.type === 'upcoming'" class="flex flex-col gap-2">
          <div class="flex items-start">
            <img src="@/assets/MyPatient/phone_number.svg" class="mr-1" alt="Title" />
            <div class="text-wrap"><span class="text-[10px] text-[#666]">Upcoming Appointment:</span><br>{{ cardData.content.date }}<br>{{ cardData.content.time }}<br><span class="text-[10px] text-[#666]">Estimated Meeting time:</span><br>{{ cardData.content.estimatedDuration }}<br><span class="text-[10px] text-[#666]">Meeting Agenda:</span><br>{{ cardData.content.description }}</div>
          </div>
        </div>
        <div v-else-if="cardData.type === 'event'" class="flex flex-col gap-2">
          <div class="flex items-start">
            <img src="@/assets/MyPatient/event_available.svg" class="mr-1" alt="Title" />
            <div class="text-wrap">{{ cardData.content.date }}<br>{{ cardData.content.time }}<br>{{ cardData.content.description }}</div>
          </div>
        </div>
        <div v-else-if="cardData.type === 'billing'" class="flex flex-col gap-2">
          <div class="flex items-start">
            <img src="@/assets/MyPatient/sample_package.svg" class="mr-1" alt="Title" />
            <div class="text-wrap">{{ cardData.content.date }}<br>{{ cardData.content.type }}<br>{{ cardData.content.status }}</div>
          </div>
        </div>
        <div v-else-if="cardData.type === 'health'" class="flex flex-col gap-2">
          <div class="flex items-start">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" class="mr-1 shrink-0">
              <path d="M10.125 5.0625C10.125 5.68125 9.61875 6.1875 9 6.1875C8.38125 6.1875 7.875 5.68125 7.875 5.0625C7.875 4.44375 8.38125 3.9375 9 3.9375C9.61875 3.9375 10.125 4.44375 10.125 5.0625ZM9 0C4.02975 0 0 4.02975 0 9C0 13.9703 4.02975 18 9 18C13.9703 18 18 13.9703 18 9C18 4.02975 13.9703 0 9 0ZM9 16.3125C4.96125 16.3125 1.6875 13.0388 1.6875 9C1.6875 4.96125 4.96125 1.6875 9 1.6875C13.0388 1.6875 16.3125 4.96125 16.3125 9C16.3125 13.0388 13.0388 16.3125 9 16.3125ZM9 7.875C8.535 7.875 8.15625 8.25375 8.15625 8.71875V13.7813C8.15625 14.2463 8.535 14.625 9 14.625C9.465 14.625 9.84375 14.2463 9.84375 13.7813V8.71875C9.84375 8.25375 9.465 7.875 9 7.875Z" fill="#374957"/>
            </svg>
            <div class="text-wrap">
              <span class="text-[10px] text-[#666]">Vital & Measurements:</span><br>
              <template v-if="cardData.content.height">Height: {{ cardData.content.height }} cm<br></template>
              <template v-if="cardData.content.weight">Weight: {{ cardData.content.weight }} kg<br></template>
              <template v-if="cardData.content.bmi">BMI: {{ cardData.content.bmi }}<br></template>
              <template v-if="cardData.content.heartRate">Heart Rate: {{ cardData.content.heartRate }} BPM<br></template>
              <template v-if="cardData.content.temperature">Temperature: {{ cardData.content.temperature }} °F<br></template>
              <template v-if="cardData.content.systolic && cardData.content.diastolic">BP: {{ cardData.content.systolic }}/{{ cardData.content.diastolic }} mmHg</template>
            </div>
          </div>
        </div>
      </div>
      <div v-if="cardData.optionIcon && cardData.optionIcon !== 'none'" class="flex items-start min-w-[30px] w-full justify-end">
        <img :src="optionIcon" alt="Option" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PinCard',
  props: {
    cardData: {
      type: Object,
      required: true
    }
  },
  computed: {
    titleIcon() {
      const icons = {
        basic: require('@/assets/MyPatient/basic_info.svg'),
        medical: require('@/assets/MyPatient/medical_information.svg'),
        calendar: require('@/assets/MyPatient/calender.svg'),
        billing: require('@/assets/MyPatient/billing.svg')
      };
      return icons[this.type] || icons.basic;
    },
    pinIcon() {
      return this.cardData.isPinned 
        ? require('@/assets/MyPatient/Pined.svg') 
        : require('@/assets/MyPatient/NotPine.svg');
    },
    optionIcon() {
      const icons = {
        edit: require('@/assets/MyPatient/Edit.svg'),
        download: require('@/assets/MyPatient/file_download.svg'),
        confirm: require('@/assets/MyPatient/task_alt.svg')
      };
      return icons[this.cardData.optionIcon] || icons.edit;
    }
  },
  methods: {
    togglePin() {
      this.$emit('toggle-pin', !this.isPinned);
    },
    editCard() {
      this.$emit('edit-card', this.type);
    }
  }
}
</script>

<style scoped>
.pin-card {
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  gap: 10px;
  box-shadow: 0 1px 15px 0 rgba(74, 74, 74, 0.15);
}
.report-ready{
  display: flex;
width: 152px;
height: 28px;
padding: 4px 16px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 10px;
border-radius: 20px;
background: #E5F1FB;
color: var(--IconGrey, #374957);
text-align: center;
text-overflow: ellipsis;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 142.857% */
letter-spacing: 0.25px;
}
</style>
